import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eventType'
})
export class EventTypePipe implements PipeTransform {

  transform(theEvent: number): string {
    
    switch (theEvent) {
      case 0:
        return "Unknown"
    
    
      case 1:
        return "Device"
    
    
      case 2:
        return "Port"
 
    
      case 3:
        return "Site"

    
      case 4:
        return "Analog"

    
      default:
        break;
    }

  }

}
